import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import * as AppState from '../../../../AppState';
import useDebounce from '../../../../hooks/useDebounce';
import HomeTypeOption from './HomeTypeOption';
import TownhouseIcon from './TownhouseIcon';
import './HomeType.scss';

const homeTypeObjects = [
	{
		label: 'House',
		icon: 'home-alt'
	},
	{
		label: 'Townhouse',
		icon: TownhouseIcon
	},
	{
		label: 'Condo',
		icon: 'building',
		icon2: 'building'
	},
	// {
	// 	label: 'Multi-family',
	// 	icon: 'city'
	// },
	{
		label: 'Manufactured',
		icon: 'caravan'
	},
	// {
	// 	label: 'Co-op',
	// 	icon: 'handshake-alt'
	// },
	{
		label: 'Apartments',
		icon: 'hotel'
	},
	{
		label: 'Land',
		icon: 'trees'
	},

	// {
	// 	label: 'Other',
	// 	icon: 'gopuram'
	// }
];

const HomeType = () => {
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);
	const [homeTypes, setHomeTypes] = useState<string[]>(gsFilters.homeTypes);

	const globalHomeTypes = gsFilters.homeTypes;
	useEffect(() => {
		setHomeTypes(globalHomeTypes);
	}, [JSON.stringify(globalHomeTypes)]);

	useDebounce(() => {
		setGsFilters(currVal => ({ ...currVal, homeTypes }));
	}, 1000, [homeTypes]);

	return (
		<>
			<h2>Home Type</h2>
			<div className="d-flex flex-wrap">
				<div className="row filter__hometype">
					{homeTypeObjects.map((homeType) =>
						<HomeTypeOption
							homeTypes={homeTypes}
							setHomeTypes={setHomeTypes}
							homeType={homeType.label}
							key={homeType.label}
							icon={homeType.icon}
							icon2={homeType.icon2} />
					)}
				</div>
			</div>
		</>
	);
};

export default HomeType;
